import styled from '@emotion/styled';
import { Project } from '@gameonly/core';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate, Location } from 'react-router-dom';
import { getProjectTitle } from '../../project/context/useProject';
import keyify from '../../project/parameters/keyify';
import { ReactComponent as HomeIcon } from '../../ui/icons/home.svg';
import { ReactComponent as NextIcon } from '../../ui/icons/next.svg';
import { IconContainer } from './Headers';

const ProjectBreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: white;
`;

export const isPage = (location: Location)  => {
  const isResults = location.pathname.includes('/results');
  const isActions = location.pathname.includes('/actions');
  const isTour = location.pathname.includes('/tour');
  const isProject = !isResults && !isActions && !isTour;
  return { isResults, isActions, isTour, isProject };
}

export const ProjectBreadcrumb = ({ project }: { project: Project }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['project']);
  const projectTitle = getProjectTitle(
    project,
    t(`model:${keyify(project?.model.name)}.defaultTitle`),
  );

  const { isResults, isActions, isTour, isProject } = isPage(location);
  
  return (
    <ProjectBreadcrumbWrapper>
      <IconContainer onClick={() => navigate('/')} fill="white">
        <HomeIcon/>
      </IconContainer>
      <IconContainer fill="white">
        <NextIcon />
      </IconContainer>
      {isProject ? (
        <>
          <p className="h6b">{projectTitle}</p>
        </>
      ) : (
        <Link to={`/project/${project._id}`} className="h5r underline">
          {projectTitle}
        </Link>
      )}
      {isResults && (
        <>
          <IconContainer>
            <NextIcon />
          </IconContainer>
          <p className="h6b">{t('project:results-page.title')}</p>
        </>
      )}
      {isActions && (
        <>
          <IconContainer>
            <NextIcon />
          </IconContainer>
          <p className="h6b">Actions</p>
        </>
      )}
      {isTour && (
        <>
          <IconContainer>
            <NextIcon />
          </IconContainer>
          <p className="h6b" data-tour="tour-transport-title">
            Calculateur Mobilité
          </p>
        </>
      )}
    </ProjectBreadcrumbWrapper>
  );
};
